import React, {  useState,  useContext, useEffect } from 'react'
import {  Button, Col,  Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Row } from 'react-bootstrap'
import makeAnimated from 'react-select/animated';
import GlobalContext, { defaultValues } from '../GlobalContext';
import { useNavigate } from 'react-router-dom';
import "../css/sidebar.css"
import "../css/inputs.css"
import { RiCustomerService2Line, RiSettings3Line, RiMailLine, RiPhoneLine, RiWhatsappLine, RiBookletLine, RiLogoutBoxLine, RiCloseLine, RiContactsLine } from 'react-icons/ri'
import {AiOutlineNotification} from 'react-icons/ai'
import ServiceContext from '../ServiceContext';
import it_manual from '../pdf/NACplan_manual_it.pdf'
import en_manual from '../pdf/NACplan_manual_en.pdf'
import de_manual from '../pdf/NACplan_manual_de.pdf'
import fr_manual from '../pdf/NACplan_manual_fr.pdf'
import TextContext from '../TextContext';
import CustomerRequests from './CustomerRequests';
import moment from 'moment';

function decimalToHex(d, padding) {
    var hex = Number(d).toString(16);
    padding = typeof (padding) === "undefined" || padding === null ? padding = 2 : padding;

    while (hex.length < padding) {
        hex = "0" + hex;
    }

    return hex;
}
const defCategories = [
    {
        ID: 0,
        cat_name: "nocategory",
        cat_apt: 0,
        cat_color: "#ff00ff",
        loaded: true
    }
]
const fontOptions = [
    { label: "Georgia", value: "Georgia, serif" },
    { label: "Times New Roman", value: "Times New Roman, serif" },
    { label: "Arial", value: "Arial, sans-serif" },
    { label: "Tahoma", value: "Tahoma, sans-serif" },
    { label: "Trebuchet MS", value: "Trebuchet MS, sans-serif" },
    { label: "Verdana", value: "Verdana, sans-serif" },
    { label: "Courier New", value: "Courier New, monospaced" },
    { label: "tw_cen_mt", value: "tw_cen_mt, serif" },
    { label: "tw_cen_mtbold", value: "tw_cen_mtbold, serif" },
    { label: "tw_cen_mt_bold_italic", value: "tw_cen_mt_bold_italic, serif" },
    { label: "tw_cen_mt_condensedregular", value: "tw_cen_mt_condensedregular, serif" },
    { label: "tw_cen_mt_condensedbold", value: "tw_cen_mt_condensedbold, serif" },
    { label: "tw_cen_mt_condensed_extra_bRg", value: "tw_cen_mt_condensed_extra_bRg, serif" },
    { label: "tw_cen_mt_condensedmedium", value: "tw_cen_mt_condensedmedium, serif" },
]
const GetTextColorClass = (ObjColor) => {
    let color2 = JSON.parse(JSON.stringify(ObjColor.cat_color)).substring(1)
    const color = ObjColor.cat_color

    color2 = color2.match(/.{1,2}/g);

    if (parseInt(color2[0], 16) + parseInt(color2[1], 16) + parseInt(color2[2], 16) > 382)
        return `
        .MuiPaper-root[color="${color}"] {color: #000 !important;border-style: none !important;}
        .MuiPaper-root[color="${color}"] button div p{color: #000 !important}
        `
    return `
    .MuiPaper-root[color="${color}"] {color: #FFF !important;border-style: none !important;}
    .MuiPaper-root[color="${color}"] button div div p{color: #FFF !important}
    `
}
const isInteger = (number) => {
    if (!/^["|']{0,1}[-]{0,1}\d{0,}(.{0,1}\d+)["|']{0,1}$/.test(number)) return false;
    return !(number - parseInt(number));
}
const Leftbar = () => {
    const globalContext = useContext(GlobalContext)
    const serviceContext = useContext(ServiceContext)
    const textContext = useContext(TextContext)
    const navigate = useNavigate()
    const animatedComponents = makeAnimated();
    const [showCustomerService, setShowCustomerService] = useState(false)
    const [showNotifys, setShowNotifys]= useState(false)
    const [showRequests, setShowRequests]= useState(false)
    const [notifys, setNotifys] = useState([])
    const [unRead, setUnRead]=useState(0)
    const [requestsNumber, setRequestsNumber] = useState(0)
    const [showLogoutConfirm, setShowLogoutConfirm] = useState(false)


    const checkUnRead=async()=>{
        const lastAcces=globalContext.get.User.use_last_read
        const newNot=notifys.filter(not=> not.not_time>=lastAcces)
        setUnRead(newNot.length)
        //console.log(newNot.length)
    }
    const loadNotifys= async()=>{
        let resp = await fetch(`${globalContext.get.backendUrl}/papiv1/notifys`, {
            method: 'GET',
            credentials: 'include'
        })
        let respValue = await resp.json()
        let lNotifys=[]
        if (resp.status == 200) {
            lNotifys=respValue.data
        }
        
        const today=moment().format('MM-DD')

        const bithdayCustomers= globalContext.get.customers.filter((cus)=>{
            if(!cus.cus_birthday){
                return false
            }
            if(cus.cus_birthday.substring(5)==today){
                return true
            } else {
                return false
            }
        })
        bithdayCustomers.forEach(cus=>{
            lNotifys.push({
                not_time: moment().unix(),
                not_header: `${textContext.get(['customers', 'info_customers'], ['festa'], textContext.value)} ${cus.cus_name} ${cus.cus_surname}`,
                not_body: `${textContext.get(['customers', 'info_customers'], ['oggi_festa'], textContext.value)} ${cus.cus_name} ${cus.cus_surname}`,
            })
        })
        setNotifys(lNotifys)
    }
    const logout= async()=>{
        globalContext.set(draft=>{
            draft.showUsersList=1
        })
    }
    const endLogout= async()=>{
        const resp = await fetch(`${globalContext.get.backendUrl}/login`, {
            method: 'DELETE',
            credentials: 'include',
        })
        const respValue = await resp.json()
        globalContext.set(defaultValues)
        localStorage.clear();
        navigate('/')
    }
    const isLogged = async () => {
        const resp = await fetch(`${globalContext.get.backendUrl}/login`, {
            method: 'GET',
            credentials: 'include',
        })
        const respValue = await resp.json()

        if (resp.status == 200) {
            return true
        } else {
            return false
        }
    }
    const updateLastRead= async()=>{
        let resp = await fetch(`${globalContext.get.backendUrl}/papiv1/notifys`, {
            method: 'POST',
            credentials: 'include'
        })
        let respValue = await resp.json()

        if (resp.status == 200) {
            setUnRead(0)
        }
    }
    const downloadManual=async ()=>{
        const lang=textContext.value.activeLang
        if(lang=='it-IT'){
            window.open(it_manual)
        } else if(lang=='en-US'){
            window.open(en_manual)
        } else if(lang=='de-DE'){
            window.open(de_manual)
        } else if(lang=='fr-FR'){
            window.open(fr_manual)
        }
    }

    useEffect(()=>{
        loadNotifys()
        const check = async () => {
            if (!await isLogged()) {
                logout()
            }
        }
        check()
    
        const checkLog = setInterval(async () => {
            if (!await isLogged()) {
                logout()
            }
        }, 30000);
    
        return () => {
            clearInterval(checkLog);
        }
    },[])
    useEffect(()=>{
    if(showNotifys && unRead){
    updateLastRead()
    }
    },[showNotifys])
    useEffect(() => {
        if (globalContext.get.User.ID) {
            checkUnRead()
        }
    }, [globalContext.get, notifys])
    useEffect(()=>{
        if(globalContext.get.showUsersList===2){
            endLogout()
        }
    },[globalContext.get.showUsersList])

    return (
        <div className='sidebar-leftbar' style={{ backgroundColor: globalContext.get.Theme.palette[2], height: "75vh" }}>
            {globalContext.get.selectedShop&&globalContext.get.selectedShop.sho_enable_cr?(
            <div className='d-flex justify-content-center' style={{ cursor: 'pointer'}} onClick={() => setShowRequests(true)}>
                <div className={`sidebar-button-container d-flex justify-content-center`} >
                    <RiContactsLine size={`34pt`} className='sidebar-sidebar-text' />
                    {requestsNumber?(
                    <div className='sidebar-notify-circle'>
                        {requestsNumber}
                    </div>
                    ):(<></>)}
                </div>
            </div>
            ):(<></>)}
            <div className='d-flex justify-content-center' style={{ cursor: 'pointer' , marginTop:'5vh'}} onClick={() => setShowNotifys(true)}>
                <div className={`sidebar-button-container d-flex justify-content-center`} >
                    <AiOutlineNotification size={`34pt`} className='sidebar-sidebar-text' />
                    {unRead?(
                    <div className='sidebar-notify-circle'>
                        {unRead}
                    </div>
                    ):(<></>)}
                </div>
            </div>
            <div className='d-flex justify-content-center' style={{ cursor: 'pointer' , marginTop:'5vh'}} onClick={() => setShowCustomerService(true)}>
                <div className={`sidebar-button-container d-flex justify-content-center`} >
                    <RiCustomerService2Line size={`34pt`} className='sidebar-sidebar-text' />
                </div>
            </div>
            <div className='d-flex justify-content-center' style={{ cursor: 'pointer', marginTop:'5vh'}} onClick={() => serviceContext.set(draft=>{draft.showSettings=true})}>
                <div className={`sidebar-button-container d-flex justify-content-center`} >
                    <RiSettings3Line size={`34pt`} className='sidebar-sidebar-text' />
                </div>
            </div>
            <div className='d-flex justify-content-center' style={{ cursor: 'pointer', marginTop:'5vh' }} onClick={()=>setShowLogoutConfirm(true)}>
                <div className={`sidebar-button-container d-flex justify-content-center`} >
                    <RiLogoutBoxLine size={`34pt`} className='sidebar-sidebar-text' />
                </div>
            </div>

            <CustomerRequests show={showRequests} setShow={setShowRequests} setRequestsNumber={setRequestsNumber} />
            <Modal show={showCustomerService} onHide={() => setShowCustomerService(false)}>
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title light-color'> {textContext.get(['leftbar', 'customer_service'], ['title'], textContext.value)}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <p>
                    {textContext.get(['leftbar', 'customer_service'], ['body1'], textContext.value)} <br /> 
                    {textContext.get(['leftbar', 'customer_service'], ['body2'], textContext.value)}
                    <ul>
                        {globalContext.get.Shop.sho_default_prefix=='39'?
                            <li>
                                {textContext.get(['leftbar', 'customer_service'], ['li1'], textContext.value)}
                                <span style={{ cursor: 'copy' }} onClick={() => navigator.clipboard.writeText('+39 331 467 7555')}>
                                 +39 331 467 7555
                                </span>
                            </li>
                        :
                            <li>
                                {textContext.get(['leftbar', 'customer_service'], ['li1'], textContext.value)} 
                                <span style={{ cursor: 'copy' }} onClick={() => navigator.clipboard.writeText('+41 76 579 4367')}>
                                    {textContext.get(['leftbar', 'customer_service'], ['a1'], textContext.value)}
                                </span>
                            </li>
                        }
                        <li> 
                            {textContext.get(['leftbar', 'customer_service'], ['li2'], textContext.value)} 
                            <span style={{ cursor: 'copy' }} onClick={() => navigator.clipboard.writeText('assistenza@nacweb.ch')}>
                                {textContext.get(['leftbar', 'customer_service'], ['a2'], textContext.value)}
                            </span>
                        </li>
                    </ul>
                    </p>
                </ModalBody>
                <ModalFooter className='d-block'>
                    <Row>
                        <Col className='d-flex justify-content-center'>
                            <button type='button' className='nac-button nac-green' onClick={downloadManual} > <RiBookletLine size={'24pt'} /> </button>
                        </Col>
                        <Col className='d-flex justify-content-center'>
                            <button type='button' className='nac-button' onClick={() => window.open('mailto:assistenza@nacweb.ch?subject=Richiesta di assistenza')} > <RiMailLine size={'24pt'} /> </button>
                        </Col>
                        <Col className='d-flex justify-content-center'>
                            <button type='button' className='nac-button' onClick={() => window.open('https://api.whatsapp.com/send?phone=41765794367')} ><RiWhatsappLine size={'24pt'} /> </button>
                        </Col>
                        <Col className='d-flex justify-content-center'>
                            <button type='button' className='nac-button' onClick={() => window.open('tel:+41765794367')} ><RiPhoneLine size={'24pt'} /> </button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
            <Modal show={showNotifys} onHide={() => setShowNotifys(false)}>
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title light-color'>{textContext.get(['leftbar', 'notify'], ['title'], textContext.value)}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className='sidebar-notifys-container' >
                        {notifys.length==0&&(
                            <div className='sidebar-notify-container'>
                            <p className='sidebar-notify-header'>{textContext.get(['leftbar', 'notify'], ['none'], textContext.value)}</p>
                        </div>
                        )}
                        {notifys.map(not=>(
                            <div key={not.ID} className='sidebar-notify-container'>
                                <p className='sidebar-notify-header'>{not.not_header}</p>
                                <hr style={{width: '90%', marginLeft: '5%', marginTop: '10px', marginBottom: '10px'}} />
                                <p className='sidebar-notify-body' dangerouslySetInnerHTML={{__html: not.not_body}} />
                            </div>
                        ))}
                    </div>
                </ModalBody>
            </Modal>
            <Modal show={showLogoutConfirm} onHide={() => setShowLogoutConfirm(false)}>
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title light-color'>{textContext.get(['leftbar', 'exit'], ['title'], textContext.value)}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <p>
                        {textContext.get(['leftbar', 'exit'], ['log'], textContext.value)}
                    </p>
                </ModalBody>
                <ModalFooter className='d-block'>
                    <Row>
                        <Col className='d-flex justify-content-start'>
                            <Button variant='success' onClick={() => setShowLogoutConfirm(false)}>{textContext.get(['leftbar', 'exit'], ['back'], textContext.value)}</Button>
                        </Col>
                        <Col className='d-flex justify-content-end'>
                            <Button variant='danger' onClick={logout} >{textContext.get(['leftbar', 'exit'], ['continue'], textContext.value)}</Button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
        </div>
    )
}


export default Leftbar